import React from 'react';
import {
  getGcPhotoTripleItems,
  getGcPhotoTripleLayoutModifier,
  getPhotoImgAlt,
} from '../../utils/bookChapterPhoto';

const StackItem = ({ photo }) => (
  <div className="gc-read-photos-triple__stack-item">
    <div className="gc-read-photos-triple__stack-media">
      <img
        src={photo.image.fluid.src}
        alt={getPhotoImgAlt(photo?.image?.alt, photo?.caption?.text || '')}
        loading="lazy"
      />
    </div>
    {photo?.caption?.text && (
      <figcaption className="gc-read-photos-triple__caption">{photo.caption.text}</figcaption>
    )}
  </div>
);

/** Three GC photos: two stacked (grid_4) + one tall column (grid_3). */
export default function GcReadPhotosTriple({ photos }) {
  const { stack, tall } = getGcPhotoTripleItems(photos);

  if (!stack.length || !tall?.image?.fluid?.src) return null;

  const layoutModifier = getGcPhotoTripleLayoutModifier(photos);

  return (
    <div className={`gc-read-photos-triple gc-read-photos-triple--${layoutModifier}`}>
      <div className="gc-read-photos-triple__stack">
        {stack.map((photo, idx) => (
          <StackItem photo={photo} key={photo.image.fluid.src || idx} />
        ))}
      </div>
      <div className="gc-read-photos-triple__tall">
        <div className="gc-read-photos-triple__tall-media">
          <img
            src={tall.image.fluid.src}
            alt={getPhotoImgAlt(tall?.image?.alt, tall?.caption?.text || '')}
            loading="lazy"
          />
        </div>
        {tall?.caption?.text && (
          <figcaption className="gc-read-photos-triple__caption">{tall.caption.text}</figcaption>
        )}
      </div>
    </div>
  );
}
